import { Section } from "../../../_enums/jobAndTalent";

export interface ScreenSetting {
  candidateName: string,
  jobDetails: string

}


 export const AllowedSectionsForIndexDb = [
  Section.PanelShortlistingFormA,
  Section.PanelShortlistingFormB,
  Section.PanelInterviewingForm,
  Section.ScreeningForm,
  Section.InitialSift,
  Section.Shortlisting,
];

export let IndexDBLocation = {
  CandidateListLeftAction: 1,
  CandidateDetailView: 2
};


export let IndexDBFormTypes = {
  PanelShortlistingFormA: 37,
  PanelShortlistingFormB: 38,
  PanelInterviewingForm: 39,
  InitialSift: 31,
  Shortlisting: 32,
  PanelShortlisting: 32,
  ScreeningForm: 30,
};


export interface MapAssessmentParams {
  jobId: number;
  candidateId: number;
  menuItemName: string;
  UserId: number;
  candidateFormId: number;
  formId: number;
  candidateType: number;
  sectionNo: number;
  obDocumentId: number;
  questions: AssessmentFormQuestions;
  addedLocation: string;
  panelType?: string;
  assessmentFormType: string;
  obDocumentGuid: string;
  type: string;
}



export interface AssessmentFormQuestions {

  applicationFormQuestions: MapApplicationFormQuestion[],
  applicationFormQuestionOptions: MapApplicationFormQuestionOption[],
  applicationFormQuestionMatrixQuestions: MapApplicationFormQuestionMatrixQuestion[],
  applicationFormQuestionMatrixChoices: MapApplicationFormQuestionMatrixChoice[],
  applicationFormQuestionMatrixPoints: MapApplicationFormQuestionMatrixPoint[]
}



export interface MapApplicationFormQuestion {
  id: number;
  applicationFormId: number;
  questionNo: number;
  questionText: string;
  questionAnswer: string;
  selectedId: number;
  maximumPossiblePoints: number;
  clientMarks: number;
  totalPoints: number;
  questionType: string;
  isMatrix: string;
}

export interface MapApplicationFormQuestionOption {
  id: number;
  applicationFormQuestionId: number;
  applicationFormId: number;
  isCorrect: string;
  points: number;
  optOrder: number;
  optionNo: number;
  optiontext: string;
  isOther: boolean;
  isSelected: boolean;
  selectedOrder: number;
  optionText: string;
}

export interface MapApplicationFormQuestionMatrixChoice {

  id: number;
  applicationFormQuestionId: number;
  selectedId: number;
  questionChoice: string;
  optionNo: number;
}


export interface MapApplicationFormQuestionMatrixQuestion {
  id: number;
  applicationFormQuestionId: number;
  questionText: string;
  optionNo: number;
  selectedId: number;
}


export interface MapApplicationFormQuestionMatrixPoint {

  id: number;
  applicationFormQuestionId: number;
  questionMatrixQuestionId: number;
  applicationFormQuestionMatrixQuestionId: number;
  questionTemplatesMatrixChoiceId: number;
  isCorrect: string;
  points: number;
  optionNo: number;
  isSelected: boolean;
}


export interface MapApplicationFormQuestionOption {
  id: number;
  applicationFormQuestionId: number;
  applicationFormId: number;
  isCorrect: string;
  points: number;
  optOrder: number;
  optionNo: number;
  optiontext: string;
  isOther: boolean;
  isSelected: boolean;
  selectedOrder: number;
  optionText: string;
}

